import { Popover } from 'antd';
import { getRandomColor } from '../create-edit-annual-review/helper';
import { getInitials } from '../create-edit-annual-review/helper';

interface Props {
  user: any;
}

const ViewUserTooltip = ({ user }: Props) => {
  const content = (
    <div className="flex flex-col gap-y-4">
      <div>
        <div className="text-[#A6A6A6]">Designation</div>
        <div>
          {user?.designation || ''}
          {(user?.tier ?? null) !== null ? `(Tier ${user?.tier})` : ''}
        </div>
      </div>
      <div>
        <div className="text-[#A6A6A6]">Mentor</div>
        <div className="capitalize">
          <div className="font-[600]">{user?.mentor?.name || ''}</div>
          <div>
            {user?.mentor?.designation || ''}{' '}
            {(user?.mentor?.tier ?? null) !== null
              ? `(Tier ${user?.mentor?.tier})`
              : ''}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <Popover content={content} trigger="hover" placement="bottomLeft">
      <div className="flex items-center">
        {user?.profilePic ? (
          <img
            src={user.profilePic}
            alt="Profile"
            className="rounded-full w-14 h-14"
          />
        ) : (
          <div
            className={`rounded-full w-14 h-14 flex items-center justify-center text-white ${getRandomColor(user.name)}`}
          >
            {getInitials(user.name)}
          </div>
        )}
        <span className="capitalize font-[500] ml-2">{user?.name}</span>
      </div>
    </Popover>
  );
};

export default ViewUserTooltip;
